import { useEffect } from 'react';
import { useAppDispatch, useAppState } from '@/store';
import {
  getSuggestedFaqs,
  selectSuggestedFaqs,
  selectSuggestedFaqsIsLoading,
  selectSuggestedFaqsPagination,
} from '../feature';
import { GetSuggestedFaqsDTO } from '../dtos';
import { TSuggestedFaqFilters } from '../helpers';

export const useGetSuggestedFaqs = (filters: TSuggestedFaqFilters, page: number) => {
  const dispatch = useAppDispatch();
  const suggestions = useAppState(selectSuggestedFaqs);
  const isLoading = useAppState(selectSuggestedFaqsIsLoading);
  const pagination = useAppState(selectSuggestedFaqsPagination);

  useEffect(() => {
    dispatch(getSuggestedFaqs(new GetSuggestedFaqsDTO({ page, ...filters })));
  }, [dispatch, filters, page]);

  return { suggestions, isLoading, pagination };
};
